import * as React from 'react';
import { COLORS } from '..';
import { SystemIcons } from '../icons';
import { ModalNoteSection } from './ModalStyles';

interface NoteProps {
  note: string | React.ReactNode;
  icon?: React.ReactNode;
  state?: string;
  size?: string;
}

export const ModalNote: React.FunctionComponent<NoteProps> = ({ note, icon, size, state = 'neutral' }) => {
  const stateVal = state.toLowerCase();

  switch (stateVal) {
    case 'positive':
      return (
        <ModalNoteSection state={stateVal} size={size}>
          {icon ? icon : <SystemIcons.CheckMark color={COLORS.correct_500} />}
          <span>{note}</span>
        </ModalNoteSection>
      );

    case 'warning':
      return (
        <ModalNoteSection state={stateVal} size={size}>
          {icon ? icon : <SystemIcons.TechnicalWarning color={COLORS.warning_500} />}
          <span>{note}</span>
        </ModalNoteSection>
      );

    case 'critical':
      return (
        <ModalNoteSection state={stateVal} size={size}>
          {icon ? icon : <SystemIcons.TechnicalWarning color={COLORS.warning_500} />}
          <span>{note}</span>
        </ModalNoteSection>
      );

    default:
      return (
        <ModalNoteSection state={stateVal} size={size}>
          {icon ? icon : <SystemIcons.Information color={COLORS.primary_500} className={size} />}
          <span>{note}</span>
        </ModalNoteSection>
      );
  }
};

export default ModalNote;
